// extracted by mini-css-extract-plugin
var _1 = "webpack-pages-StudyList-StudyListItem-components-NotesModal-NotesDialog-module__DeleteNoteButton";
var _2 = "webpack-pages-StudyList-StudyListItem-components-NotesModal-NotesDialog-module__EditNoteButton";
var _3 = "webpack-pages-StudyList-StudyListItem-components-NotesModal-NotesDialog-module__FooterStack";
var _4 = "webpack-pages-StudyList-StudyListItem-components-NotesModal-NotesDialog-module__Note";
var _5 = "webpack-pages-StudyList-StudyListItem-components-NotesModal-NotesDialog-module__Title";
export { _1 as "DeleteNoteButton", _2 as "EditNoteButton", _3 as "FooterStack", _4 as "Note", _5 as "Title" }
